module.exports = __webpack_public_path__ + "img/electronicien_MT_078.bf431440.jpg";